
<template>

	<mymodal ref="modal" title="Подбор объектов-аналогов" ok="Применить" :reset="reset" width="1000" :check="check" :submit="submit" :ok_hide="false">
		<b-overlay :show="wait">
		<div class="analogues-selection">
			<b-form-checkbox
				v-model="all"
			>
				Все объекты-аналоги
			</b-form-checkbox>
	
			<div v-if="filter && attrs" :class="'analogues-selection_rows' + (all ? ' natural-300' : '')">
				<b-row v-for="field in fields" :key="field.label">

					<b-col cols="4">{{ field.label }}</b-col>

					<template v-if="attrs[field.key]">
						<template v-if="attrs[field.key] && attrs[field.key].reference">
							<b-col><v-select class="v-select-multiple" multiple :closeOnSelect="false" :deselectFromDropdown="true"
									:options="attrs[field.key].reference"
									v-model="filter[field.key]"
									label="label"
									:reduce="value => value.key"
									:disabled="all"
									appendToBody appendToParent
								>

									<template #option="{ key, label }">
										<b-form-checkbox v-model="filter[field.key]" :value="key" class="v-select-multiple_option">
											{{ label }}
										</b-form-checkbox>
									</template>

								</v-select>
							</b-col>
						</template>
	
						<template v-else-if="attrs[field.key].type == 'date'">
							<b-col><date_picker size="sm" v-model="filter[field.key].from" :readonly="all" /></b-col>
							<b-col><date_picker size="sm" v-model="filter[field.key].to" :readonly="all" /></b-col>
						</template>
	
						<template v-else>
							<b-col><v-select :options="operators" :value="filter[field.key].operator"
								@input="(value) => set_value(field.key, 'operator', value)" :disabled="all" appendToBody appendToParent /></b-col>
							<b-col><b-form-input v-if="filter[field.key].operator && filter[field.key].operator != 'пусто' && filter[field.key].operator != 'не пусто'" size="sm" v-model="filter[field.key].value" :readonly="all" /></b-col>
						</template>
					</template>

				</b-row>

				<span class="small">* - все условия применяются с логическим оператором "И"</span>
			</div>
		</div>
	</b-overlay>
	</mymodal>

</template>

<script>

import moment from "moment"
import api from "../../../api"
import attrs from "../../../api/attrs"
import mymodal from "../../widgets/modal"
import date_picker from "../../widgets/date_picker"

export default
{
	props :
	{
	},

	components:
	{
		mymodal,
		date_picker
	},

	data()
	{
		return {
			all : false,
			filter : null,
			fields :
			[
				{ label : "Вид объекта недвижимости", key: "attrs.ObjectType" },
				{ label : "Дата сделки / Предложения / Оценки", key: "attrs.transaction_date" },
				{ label : "Источник информации", key: "attrs.marketing_source" },
				{ label : "КЛАДР", key: "attrs.KLADR" },
				{ label : "ОКТМО", key: "attrs.OKTMO" },
				{ label : "Сегмент", key: "attrs.Segment" },
				{ label : "Функциональная группа", key: "attrs.functional_group" }
			],
			operators :
			[
				"пусто",
				"не пусто",
				"=",
				"не равно",
				"содержит",
				"не содержит",
				"регулярное выражение",
				"начинается с",
				"заканчивается на"
			],
			wait : false,
		}
	},

	methods :
	{
		check()
		{
			var query

			try
			{
				query = this.compile()
			}
			catch (ex)
			{
				console.log("Ошибка:", ex)

				return false
			}

			if(this.all || query.length)
				return true

			return false
		},

		compile()
		{
			if(this.filter == null)
				throw "Фильтр пуст"

			if(this.all)
				return

			var query = []

			this.fields.forEach(
				field =>
				{
					const key = field.key

					if(this.filter[key] == null)
						return

					const attr_key = "current_version." + key
					const attr = this.attrs[key]

					if(attr.reference_id != null)
					{
						const op = this.filter[key]

						if(op.length == 0)
							throw "Пустой " + key

						var or = []

						op.forEach(
							value =>
								or.push({ "keys":[attr_key],"operation":"eqs","args":[value],"reference":attr.reference_id})
							)
										
						query.push({ "or" : or })
					}
					else if(attr.type == "date")
					{
						const from = this.filter[key].from
						const to = this.filter[key].to

						var and = []

						if(moment(from) > moment(to))
							throw "Левая граница даты больше, чем правая"

						if(from != null)
							and.push({ "keys":[attr_key],"operation":"gted","args":[from]})

						if(to != null)
							and.push({ "keys":[attr_key],"operation":"lted","args":[to]})

						if(and.length)
							query.push({ "and" : and })
					}
					else
					{
						const op = this.filter[key].operator
						const value = this.filter[key].value

						if(op != null)
						{
							var prepared_op

							if(op == "пусто")
								prepared_op = "empty"
							else if(this.filter[key].operator == "не пусто")
								prepared_op = "notempty"
							else 
							{
								if(value == null || value == "")
									throw "Значение для " + key + ", оператора " + op + " пустое"

								switch(op)
								{
									case "=":

										prepared_op = "eqs"
										break

									case "не равно":

										prepared_op = "nes"
										break

									case "содержит":

										prepared_op = "contain"
										break

									case "не содержит":

										prepared_op = "not_contain"
										break;

									case "регулярное выражение":

										prepared_op = "regexp"
										break;

									case "начинается с":

										prepared_op = "begin_with"
										break;

									case "заканчивается на":

										prepared_op = "end_on"
										break;
								}
							}
							
							if(prepared_op == null)
								throw "Некорректная операция: " + key  + ", " + op

							query.push({ "keys":[attr_key],"operation":prepared_op,"args":[value]})
						}
					}
				})

			return query
		},

		reset()
		{
			this.attrs = null
			this.filter = null
			this.wait = false

			attrs.get(this)
				.then(
					data =>
					{
						const fields_key = this.fields.map(field => field.key)

						const filter = {}
						const attrs = {}

						data.attrs.forEach((_attr) => {
							if (fields_key.includes(_attr.key))
							{
								var attr = api.deep_clone(_attr)

								if (attr.reference && attr.reference.original)
								{
									attr.reference_id = attr.reference.id

									attr.reference = attr.reference.values.map((value) => ({
										key: value,
										label: api.format_reference(attr.reference, value)
									}))
								}
								else if (attr.type == "date")
								{
									filter[attr.key] = { from: null, to: null }
								}
								else
								{
									filter[attr.key] = { operator: null, value: "" }
								}

								attrs[attr.key] = attr
							}
						})

						
						this.attrs = attrs
						this.filter = filter
					}
				)
		},

		set_value(field, key, value)
		{
			const new_filter = api.deep_clone(this.filter)

			new_filter[field][key] = value

			if (key === "operator")
			{
				new_filter[field].value = ""
			}

			this.filter = new_filter
		},

		execute()
		{
			this.$refs.modal.execute()
		},

		submit()
		{
			this.$bvModal.msgBoxConfirm(
				"Вы действительно хотить обновить выборку ОА? Это приведет к сбросу КС/УПКС ОО и рассчитанных значений ОА",
				{
					title : "Подтверждение",
					okVariant : "danger",
					okTitle : "Да",
					cancelVariant : "outline-primary-secondary",
					cancelTitle : "Нет",
					hideHeaderClose : false,
					centered : true
				})
				.then(
					value =>
					{
						if(value)
						{
							var params = {
								analogues_all: this.all,
								query : this.compile()
							}
							var set_used_params = {}

							if(! this.all)
								set_used_params.query = JSON.stringify({ "and" : params.query })

							this.wait = true

							api.call(this, "cadastral_analogues", "set_used_many", set_used_params,
								() =>
								{
									this.wait = false
									this.$emit("need_refresh", params)

									this.$refs.modal.my_hide()
								})
						}
					})
		},
	}
}

</script>

<style scoped>
.analogues-selection
{
	display: flex;
	flex-direction: column;
	gap: .5rem;
}

.analogues-selection_rows
{
	display: flex;
	flex-direction: column;
	gap: .5rem;
}
</style>

<style>
.vs__dropdown-option--selected:has(.v-select-multiple_option)
{
	color: unset !important;
}

.vs__dropdown-option--selected:has(.v-select-multiple_option)::after
{
	display: none !important;
}
</style>
